export const VIEWPORT_HD = "hd";
export const VIEWPORT_DESKTOP = "desktop";
export const VIEWPORT_TABLET = "tablet";
export const VIEWPORT_PHABLET = "phablet";
export const VIEWPORT_MOBILE = "mobile";

export const isMobile = (viewport: string) => viewport === VIEWPORT_MOBILE;
export const isPhablet = (viewport: string) => isMobile(viewport) || viewport === VIEWPORT_PHABLET;
export const isTablet = (viewport: string) => isPhablet(viewport) || viewport === VIEWPORT_TABLET;

export const MEDIA_TYPE_IMAGE = "IMAGE";
export const MEDIA_TYPE_IMAGES = "IMAGES";
export const MEDIA_TYPE_VIDEO = "VIDEO";
export const MEDIA_TYPE_360 = "IMAGE_360";
export const MEDIA_TYPE_THREEDIUM = "THREEDIUM";
export const MEDIA_TYPE_UNKNOWN = "UNKNOWN";
export type IMAGES = "IMAGES";
export type IMAGE = "IMAGE";
export type VIDEO = "VIDEO";
export type IMAGE_360 = "IMAGE_360";
export type THREEDIUM = "THREEDIUM";
export type IMedia = IMAGE | VIDEO | IMAGE_360 | IMAGES | THREEDIUM | "UNKNOWN";

export const WIDGET_TYPE_IMAGE = "IMAGE";
export const WIDGET_TYPE_IMAGES = "IMAGES";
export const WIDGET_TYPE_VIDEO = "VIDEO";
export const WIDGET_TYPE_360 = "IMAGE_360";
export const WIDGET_TYPE_TEXT = "TEXT";
export const WIDGET_TYPE_CUSTOM_BUTTON = "CUSTOM_BUTTON";
export const WIDGET_TYPE_SHAPES = "SHAPES";
export const WIDGET_TYPE_PRODUCT = "PRODUCT";
export const WIDGET_TYPE_PRODUCT_3D = "PRODUCT_3D";
export const WIDGET_TYPE_LINESHEET = "LINESHEET";

export type IWidgetType =
    | "IMAGE"
    | "IMAGES"
    | "VIDEO"
    | "IMAGE_360"
    | "TEXT"
    | "CUSTOM_BUTTON"
    | "SHAPES"
    | "PRODUCT"
    | "LINESHEET"
    | "PRODUCT_3D"
    | "UNKNOWN";

export const cdn = "cdn1.nuorder.com";

export const MAX_PRODUCT_MEDIA_COUNT = 100;

export const VIDEO_3D_IMAGE_SPECIFICATION_LINK =
    "https://helpdesk.nuorder.com/hc/en-us/articles/4405475397019-3D-images";
